import { partnerImagesApi } from 'legacy/lut/classes/services/api/PartnerImagesApi'
import { partnerImagesStoreService } from 'legacy/lut/classes/services/PartnerImagesStoreService'
import { DragNDropFileUploader, IFileSettings } from 'legacy/lut/library/dragNDrop'
import React, { useState } from 'react'
import sanitizeHtml from 'sanitize-html'

import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'
import { calculateFileLink, saveFile } from 'core/classes/helpers/saveFiles'
import { IExtendedFileData } from 'core/classes/models/IFileData'

import styles from './WidgetFieldEditor.module.scss'

interface IProps {
  defaultValue: string
  entryId: number | undefined
  fieldName: string
  fieldType: string
  handleCloseEdit: (value: string, fieldName: string) => void
  formId: number
  formCode: string
  isLogo?: boolean
  PartnerId?: any
  uid?: string
}

export const WidgetAttachmentFieldEditor = ({
  defaultValue,
  entryId,
  fieldName,
  fieldType,
  handleCloseEdit,
  formId,
  formCode,
  isLogo,
  PartnerId,
  uid,
}: IProps) => {
  const [value, setValue] = useState(defaultValue)
  const [isOpen, setIsOpen] = useState(false)
  const isUpdated = defaultValue !== value
  const [fileLoader, setfileLoader] = useState<
    (IExtendedFileData & { formCode: string }) | undefined
  >()
  const [isActive, setIsActive] = useState(true)
  const [isFileUpload, setIsFileUpload] = useState(false)
  const [newLogo, setNewLogo] = useState<any>({})

  const handlePictureChange = (files: IFileSettings[]) => {
    files.forEach((item) => {
      setfileLoader({
        formId,
        entryId: entryId ? entryId : newLogo.EntryId,
        formCode,
        fieldName,
        file: item.file,
        fileName: item.file.name,
      })
      setValue(item.value)
      setIsFileUpload(true)
    })
  }

  const getPreviewSrc = () => {
    if (isUpdated) {
      return value
    }
    return calculateFileLink({
      formId,
      fileName: value,
      fieldName,
      entryId: entryId || newLogo.EntryId,
      UID: uid || newLogo.UID,
    })
  }

  const handleCloseDialog = async (isApply: boolean) => {
    setIsActive(false)
    let result = ''
    if (isUpdated && isApply) {
      if (isFileUpload && fileLoader) {
        setValue(fileLoader.fileName)
        result = fileLoader.fileName
        await saveFile({
          formId: fileLoader.formId,
          formCode: fileLoader.formCode,
          fieldName: fileLoader.fieldName,
          models: [{ EntryId: fileLoader.entryId, file: fileLoader.file }],
        })
        setfileLoader(undefined)
      } else {
        result = defaultValue
        setValue(defaultValue)
      }
    }
    setIsOpen(false)
    handleCloseEdit(result, fieldName)
    setIsActive(true)
  }

  return (
    <>
      {isLogo ? (
        <Button
          className={styles.uploadIcon}
          iconButton={'kbase kbase-lvl-upload'}
          onClick={async () => {
            if (!entryId) {
              await partnerImagesApi.setPartnerImage(
                {
                  EntryId: 0,
                  Image: '',
                  ImageType: 'Logo',
                  PartnerId: PartnerId,
                },
                'create'
              )
              const data = await partnerImagesStoreService.getImages(PartnerId, true)
              if (data && data.length > 0) {
                const logoIndex = data.findIndex((item: any) => item.ImageType === 'Logo')
                if (logoIndex >= 0) {
                  setNewLogo(data[logoIndex])
                }
              }
            }
            setIsOpen(true)
          }}
        />
      ) : (
        <Button iconButton={'kbase kbase-edit'} onClick={() => setIsOpen(true)} />
      )}

      <ModalDialog
        show={isOpen}
        onClose={() => handleCloseDialog(false)}
        size={'sm'}
        content={() =>
          (isActive && (
            <>
              <div className={styles.editor}>
                <p className={styles.label}>{fieldName}</p>
                <DragNDropFileUploader
                  changeFileLoader={handlePictureChange}
                  acceptedFormats={'image/*'}
                />
                {fieldType === 'image' && (
                  <img
                    src={sanitizeHtml(getPreviewSrc())}
                    style={{
                      width: `100px`,
                      marginTop: '8px',
                    }}
                    alt=""
                  />
                )}
              </div>
              <div className={styles.actionBox}>
                <Button
                  iconButton={'kbase kbase-save'}
                  disabled={!isUpdated}
                  variant={'text'}
                  onClick={() => handleCloseDialog(true)}
                />
                <Button
                  iconButton={'kbase kbase-close'}
                  disabled={!isUpdated}
                  variant={'text'}
                  color={'grey'}
                  onClick={() => handleCloseDialog(false)}
                />
              </div>
            </>
          )) || <Loader />
        }
      />
    </>
  )
}
